var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAlertTriangleFullYellowmin = function SvgIconAlertTriangleFullYellowmin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    x: 10,
    y: 7,
    fill: "#000",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA436",
    d: "M18.693 16.012 13.74 6.106a2 2 0 0 0-3.578 0l-4.953 9.91a2 2 0 0 0 1.789 2.89h9.905a2 2 0 0 0 1.79-2.894M10.95 8.906a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0zm1 8.25a1.25 1.25 0 1 1 0-2.499 1.25 1.25 0 0 1 0 2.499"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlertTriangleFullYellowmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_alert_triangle_full_yellow.min.83cc7d8a8285670c4cd7538e3addb2fa.svg";